import {
  ApeironBlueButton,
  INFO_POPUP_TYPE,
  InfoPopup,
  NextImage
} from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { useVipPassContext } from '@src/contexts/battle/demo/VipPassContext'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Popup = styled(InfoPopup)`
  width: auto;
  max-width: 450px;
  min-width: 350px;

  height: fit-content;
  background-color: #171719;
  border-radius: 10px;

  .Custom-Header {
    background-color: #262829;
    height: 60px;
    padding: 20px;
    border-radius: 10px 10px 0px 0px;
    .Custom-Name {
      font-size: 24px;
    }
  }

  .Custom-Close-Button {
    height: 60px;
  }

  .Custom-Content {
    min-height: 350px;
  }
`

const MainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;

  padding: 20px 20px 30px 20px;
  gap: 20px;
`

const Image = styled(NextImage)`
  aspect-ratio: 1;

  width: 200px;
`

const RewardInfo = styled(Box)`
  font-size: 20px;
`

const ConfirmButton = styled(ApeironBlueButton)`
  width: 250px;

  font-size: 18px;
`

const VipPassLootBoxPopup = ({ open, onclose, boxName }: Props) => {
  const { currentPrize } = useVipPassContext()

  const { t } = useTranslation()

  const handleShare = useCallback(() => {
    window.open(
      'https://twitter.com/intent/tweet?url=https://x.com/ApeironNFT/status/1942161694421406024&text=LETS%20GOOOO%20🎉%0AJust%20popped%20an%20@ApeironNFT%20Divine%20Key%20and%20BAM%20-%20USDC%20added%20to%20the%20wallet!%0AEZ%20money!%20🤑%0AWhat%27s%20everyone%20else%20winning%20from%20their%20keys%3F!%20✨%0A%0A%23ApeironS7%20%23DivineKey%20%23USDC',
      '_blank'
    )
  }, [])

  return (
    <Popup
      open={open}
      type={INFO_POPUP_TYPE.BLACK}
      onClose={onclose}
      name={boxName}
    >
      <MainContainer>
        <Image src={currentPrize?.image} />

        <RewardInfo>
          {currentPrize?.name} x{currentPrize?.amount}
        </RewardInfo>

        <ConfirmButton onClick={handleShare}>{t('common.share')}</ConfirmButton>
      </MainContainer>
    </Popup>
  )
}

type Props = {
  open: boolean
  onclose?: () => void
  boxName?: string
}

export default VipPassLootBoxPopup
